export default __webpack_public_path__ + "static/media/view-icon.0b544d6f.svg";